import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ESelectionApplyTargetType } from "../../Enum/ESelectionApplyTargetType"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PostRequest } from "../../services/ApiClientService"
import { useSnackbar } from "../../context/snackbarContext"

export interface ApplySelectionRequest {
  targetType: ESelectionApplyTargetType
  mealIds: number[]
  drinkIds: number[]
  comboIds: number[]
}

export const useApplySelection = () => {
  const { t } = useTranslation(["general", "selection"])

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { showSnackbar } = useSnackbar()

  const handleApplySelection = async (
    selectionId: number,
    request: ApplySelectionRequest,
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.SELECTION.APPLY}/${selectionId}`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("selection:snackbar_association_updated_title"),
          description: t("selection:snackbar_association_updated_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  const handleRemoveSelectionApply = async (
    selectionId: number,
    request: ApplySelectionRequest,
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.SELECTION.APPLY_REMOVE}/${selectionId}/remove`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("selection:snackbar_association_removed_title"),
          description: t("selection:snackbar_association_removed_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  return { handleApplySelection, handleRemoveSelectionApply }
}
